import React, { useEffect, useState } from "react";
import axios from "axios";

export default function TotalFunds() {
  const [funds, setFunds] = useState([]);

  // ✅ Fetch only pending funds from backend
  const fetchFunds = async () => {
    try {
      const res = await axios.get("https://api.speedfollowinfo.com/api/admin/pending-funds");
      if (res.data.success) {
        setFunds(res.data.funds || []);
      }
    } catch (err) {
      console.error("❌ Fetch Pending Funds Error:", err);
    }
  };

  useEffect(() => {
    fetchFunds();
  }, []);

  // ✅ Approve / Cancel Fund instantly
  const [processingFunds, setProcessingFunds] = useState({}); // ✅ Add this line at top of component

const handleFundStatus = async (fundId, status) => {
  if (processingFunds[fundId]) return; // Prevent multiple clicks

  try {
    setProcessingFunds((prev) => ({ ...prev, [fundId]: true }));

    const res = await axios.put(
      `https://api.speedfollowinfo.com/api/admin/fund-status/${fundId}`,
      { status }
    );

    if (res.data.success) {
      setFunds((prev) => prev.filter((f) => f._id !== fundId));

      const msg = document.createElement("div");
      msg.textContent = `Fund ${status} Successfully`;
      msg.style.position = "fixed";
      msg.style.top = "20px";
      msg.style.right = "20px";
      msg.style.background =
        status === "Approved"
          ? "linear-gradient(90deg, #00ff88, #00c46a)"
          : "linear-gradient(90deg, #ff5252, #d32f2f)";
      msg.style.color = "#fff";
      msg.style.fontWeight = "600";
      msg.style.padding = "10px 18px";
      msg.style.borderRadius = "8px";
      msg.style.boxShadow = "0 0 15px rgba(0,0,0,0.4)";
      msg.style.zIndex = "9999";
      document.body.appendChild(msg);
      setTimeout(() => msg.remove(), 2500);
    }
  } catch (err) {
    console.error("❌ Fund Status Update Error:", err);
    alert("⚠️ Failed to update fund status");
  } finally {
    setProcessingFunds((prev) => ({ ...prev, [fundId]: false }));
  }
};

  return (
    <div className="p-6 text-white">
      <h2 className="text-2xl font-bold mb-5 text-[#f2a900]">
        💰 Total Funds (Pending Requests)
      </h2>

      <div className="overflow-x-auto rounded-lg shadow-lg">
        <table className="w-full text-sm text-left border border-gray-700">
          <thead className="bg-[#111827] text-[#f2a900] uppercase">
            <tr>
              <th className="p-3">Username</th>
              <th className="p-3">Email</th>
              <th className="p-3">Txn ID</th>
              <th className="p-3">Method</th>
              <th className="p-3">Amount (৳)</th>
              <th className="p-3">Created</th> {/* ✅ NEW DATE COLUMN */}
              <th className="p-3">Status</th>
              <th className="p-3 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {funds.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center p-4 text-gray-400 italic">
                  No pending fund requests
                </td>
              </tr>
            ) : (
              funds.map((fund) => (
                <tr
                  key={fund._id}
                  className="border-b border-gray-700 hover:bg-[#1f2937] transition"
                >
                  <td className="p-3">{fund.userId?.username || "Unknown"}</td>
                  <td className="p-3">{fund.userId?.email || "N/A"}</td>
                  <td className="p-3 text-[#00eaff] font-semibold">
                    {fund.transactionId}
                  </td>
                  <td className="p-3">{fund.method}</td>
                  <td className="p-3 text-[#22c55e] font-semibold">
                    ৳{fund.amount}
                  </td>

                  {/* ✅ Display Date correctly */}
                  <td className="p-3 text-gray-300">
                    {fund.createdAt
                      ? new Date(fund.createdAt).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      : "—"}
                  </td>

                  <td className="p-3">
                    <span className="bg-yellow-500 text-black font-semibold px-3 py-1 rounded-full text-xs">
                      {fund.status}
                    </span>
                  </td>

                  <td className="p-3 text-center flex justify-center gap-3">
                    <button
  onClick={() => handleFundStatus(fund._id, "Approved")}
  disabled={processingFunds[fund._id]}
  className={`${
    processingFunds[fund._id] ? "bg-gray-400 cursor-not-allowed" : "bg-green-500 hover:bg-green-600"
  } text-black font-semibold px-3 py-1 rounded-lg transition`}
>
  ✅ Approve
</button>

                    <button
                      onClick={() => handleFundStatus(fund._id, "Rejected")}
                      className="bg-red-500 hover:bg-red-600 text-white font-semibold px-3 py-1 rounded-lg transition"
                    >
                      ❌ Cancel
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}